export const whatapSample = {
    'metricName': 'cpu',
    'pcode': 108,
    'level': 'Warning',
    'metricValue': '26.808296',
    'oid': -330494549,
    'title': 'CPU Used > 10 %',
    'message': 'MEMORY is too high 90%',
    'uuid': '0dfcc0b7686c45158fbef4cfcfa45754',
    'metricThreshold': '10.0',
    'oname': 'ote-front',
    'time': 1592807171071,
    'projectName': 'OTE-SERVER',
    'status': 'on'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/whatap.ts